import { faHouse, faRefresh } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect } from 'react';
import VoxelAlert from '../../components/voxel/Alert/VoxelAlert';
import VoxelButton from '../../components/voxel/Buttons/VoxelButton';
import VoxelButtonGrid from '../../components/voxel/Buttons/VoxelButtonGrid';
import useUnsubscribeFromAllProjectsGq from '../../graphql/projects/mutations/projects/useUnsubscribeFromAllProjectsGq';

export interface UnsubscribePageProps {}

export const UnsubscribePage: React.FC<UnsubscribePageProps> = ({}) => {
  const unsubscribeMutation = useUnsubscribeFromAllProjectsGq();

  // Unsubscribe upon page load
  useEffect(() => {
    unsubscribeMutation();
  }, []);

  return (
    <div className="fixed h-1/2 w-full flex flex-col items-center justify-center content-center p-12">
      <VoxelAlert severity="info" title="Unsubscribed" widthClass="w-[396]">
        You've unsubscribed to all progress tracking emails
      </VoxelAlert>
      <div className="h-8" />
      <VoxelButtonGrid>
        <VoxelButton
          title="Take me home"
          startIcon={<FontAwesomeIcon icon={faHouse} />}
          onClick={() => (window.location.href = window.location.origin)}
        />
      </VoxelButtonGrid>
    </div>
  );
};

export default UnsubscribePage;
